// src/pages/Home.js
import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="container">
      <header className="brand">
        <img src={`${process.env.PUBLIC_URL}/andeon-icon.svg`} alt="Andeon Apps" />
        <h1>Andeon Apps</h1>
        <p>We make small, useful apps.</p>
      </header>

      <section className="section">
        <p className="section-label">About</p>
        <p>
          Andeon Apps is a small studio building tools that are simple, fast,
          and a pleasure to use.
        </p>
      </section>

      <section className="section">
        <p className="section-label">Apps</p>
        <div className="apps">
          <a
            className="app"
            href="https://uprezai.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <h3>UprezAI</h3>
            <p className="domain">uprezai.com</p>
            <p className="desc">
              AI-powered image upscaler. Enhance resolution and detail in
              seconds.
            </p>
          </a>
          <a
            className="app"
            href="https://fricori.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <h3>Fricori</h3>
            <p className="domain">fricori.com</p>
            <p className="desc">
              Turn your product photos into TikTok-ready ads in seconds. Built
              for sellers who'd rather ship than shoot.
            </p>
          </a>
        </div>
      </section>

      <section className="section contact">
        <p className="section-label">Contact</p>
        <p>
          <a href="mailto:support@andeonapps.com">support@andeonapps.com</a>
        </p>
      </section>

      <footer className="footer">
        <nav className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
          <Link to="/refund-policy">Refund Policy</Link>
        </nav>
        <p>&copy; 2026 Andeon Apps. All rights reserved.</p>
        <p>Established 2024</p>
      </footer>
    </div>
  );
};

export default Home;
